<template>
  <div>
    <div>
      <button class="strategy__heading" @click="toggleSubcontent($event)">
        <arrow-down class="subcontent__icon" />
        <span>
          <span v-html="addTagMessage"></span>
          <font-awesome-icon
            v-if="parentNodeSelected"
            v-on:click="onClearParent()"
            :icon="icon.cancel"/>
        </span>
      </button>
      <slide-up-down :active="showAddTag">
        <div
          class="add-tag">
          <input
            class="margin-right-l"
            v-on:keyup.13="addNode()"
            v-model="name"
            :placeholder="$t('variables.multipleTagsExample')">
            <font-awesome-icon
              class="add-tag-icon"
              @click="addNode()"
              :icon="icon.add"/>
        </div>
      </slide-up-down>
    </div>
    <div>
      <liquor-tree
        ref="tree"
        class="tree--small"
        @node:checked="onCheckedNode"
        @node:unchecked="onCheckedNode"
        @node:dragging:finish="emitOnChange()"
        @node:text:changed="emitOnChange()"
        :options="{ dnd: true, checkbox: true, multiple: false, parentSelect: true }" >
        <div
          slot-scope="{ node }"
          class="node-container">
          <font-awesome-icon
            v-if="node.data.id < 0"
            class="icon"
            v-on:click="onEditNode(node)"
            :icon="icon.lock"/>
          <span class="node-text">{{ node.text }}</span>
          <div
            v-if="node.data.id >= 0 && node.states.selected === true">
            <font-awesome-icon
              class="icon"
              v-on:click="onEditNode(node)"
              :icon="icon.edit"/>
            <font-awesome-icon
              class="icon"
              v-on:click="onDeleteNode(node)"
              :icon="icon.delete"/>
            <font-awesome-icon
              class="icon"
              v-on:click="onMarkNodeAsParent(node)"
              :icon="icon.add"/>
          </div>
        </div>
      </liquor-tree>
    </div>
  </div>
</template>

<script>
import LiquorTree from 'liquor-tree';
import TagsTree from '@/components/variable/TagsTree';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {
  faPlusCircle,
  faPencilAlt,
  faTrashAlt
} from '@fortawesome/pro-regular-svg-icons';
import {
  faLock,
  faTimesCircle
} from '@fortawesome/pro-solid-svg-icons';
import ArrowDown from '@/components/shared/icons/IconArrowDown';
import SlideUpDown from 'vue-slide-up-down';
import BtnPill from '@/components/shared/buttons/BtnPill';

export default {
  name: 'TagsTree',
  components: {
    BtnPill,
    LiquorTree,
    TagsTree,
    FontAwesomeIcon,
    SlideUpDown,
    ArrowDown
  },
  data () {
    return {
      name: '',
      showAddTag: false,
      checkedNodes: [],
      icon: {
        add: faPlusCircle,
        edit: faPencilAlt,
        delete: faTrashAlt,
        lock: faLock,
        cancel: faTimesCircle
      },
      parentNode: null
    };
  },
  computed: {
    addTagMessage () {
      if (this.parentNode === null) {
        return this.$t('variables.addTag');
      } else {
        const message = this.$t('variables.addChildTag') + ': <br>' + this.parentNode.text;
        return this.$t(message);
      }
    },
    parentNodeSelected () {
      return this.parentNode !== null;
    }
  },
  methods: {
    setModel (tree) {
      this.$refs.tree.setModel(tree);
    },
    addNode () {
      const name = this.name.trim();
      const nameList = name.split(',');
      let repeatedTags = [];
      for (let i = 0; i < nameList.length; i++) {
        const tag = nameList[i].trim();
        if (tag !== '') {
          if (this.$refs.tree.find(tag).length === 0) {
            // TODO let yoquese = this.$refs.tree.find('of')[0].append(tag);
            if (this.parentNode !== null) {
              this.$refs.tree.find(this.parentNode.text)[0].append(tag);
            } else {
              this.$refs.tree.append({text: tag});
            }
          } else {
            repeatedTags.push(tag);
          }
        }
      }
      this.name = '';
      this.emitOnChange(repeatedTags);
    },
    onDeleteNode (node) {
      const tree = this.$refs.tree.model;
      this.$emit('onDelete', { tree: tree, nodes: [node] });
    },
    onEditNode (node) {
      node.startEditing();
    },
    onMarkNodeAsParent (node) {
      this.parentNode = node;
      if (this.showAddTag === false) {
        this.showAddTag = true;
      }
    },
    onClearParent () {
      this.parentNode = null;
    },
    onCheckedNode (node) {
      if (node.children.length === 0 && node.states.checked === true) {
        this.checkedNodes.push(node.data.id);
      } else {
        this.checkedNodes = this.checkedNodes.filter(id => id !== node.data.id);
      }
      this.$emit('onChecked', this.checkedNodes);
    },
    emitOnChange (repeatedTags) {
      const tree = this.$refs.tree.model;
      this.$emit('onChange', { tree: tree, repeatedTags: repeatedTags });
    },
    toggleSubcontent (event) {
      let toggleTarget = event.target;
      if (!toggleTarget.classList.contains('strategy__heading')) {
        toggleTarget = toggleTarget.closest('.strategy__heading');
      }
      toggleTarget.classList.toggle('is-subcontent-open');

      this.showAddTag = !this.showAddTag;
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../stylesheets/variables.scss";

  .add-tag {
    display: flex;
    align-items: center;
    flex-grow: 1;
  }

  .add-tag-icon {
    cursor: pointer;
  }

  .icon {
    margin: $sp-margin-smaller;
    cursor: pointer;
  }

  .node-container {
    display: flex;
    align-items: center;
  }

  .node-text {
    margin-right: $sp-margin-small;
    text-align: -webkit-center;
  }

  input {
    border: 1px solid $black-trans6;
    border-radius: 2px;
    padding-left: $sp-margin-small;
    padding-right: $sp-margin-small;
    padding: $sp-margin-smaller;
    min-width: available;
    width: inherit;
  }

  .strategy {

    &__heading {
      background-color: transparent;
      border: 0;
      padding: 0.4rem 0 0;
      margin-bottom: $sp * 3;
      font-weight: 700;
      text-align: left;
      cursor: pointer;
      display: flex;
      align-items: flex-start;
      color: $jamaicol;
      &:hover,
      &:focus {
        outline: 0;
      }
      .subcontent__icon {
        margin-right: $sp-margin-small;
        flex-shrink: 0;
      }
      &.is-subcontent-open {
        .subcontent__icon {
          transform: rotate(180deg);
        }
      }
    }

    &__subcontent &__heading-toggle {
      font-size: $fs-s;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/variable/TagsTree.vue